/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type IntlService from 'embercom/services/intl';

class FinAiAgentSalesDeployChatRoute extends Route {
  @service declare intl: IntlService;

  get titleToken() {
    return this.intl.t('ai-agent.deploy.sales.chat');
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentSalesDeployChatRoute);
